import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import classnames from 'classnames';
import Box from '../../Box/index.esm.js';

var Handle = /*#__PURE__*/forwardRef(function (props, ref) {
  var active = props.active,
      rest = _objectWithoutPropertiesLoose(props, ["active"]);

  return createElement(Box, _extends({
    as: "button",
    type: "button",
    ref: ref,
    dangerouslySetClassName: classnames('range-input__handle', {
      'range-input__handle--active': active
    }),
    width: "w-4",
    height: "h-4",
    transitionProperty: "transition",
    transitionDuration: "duration-200",
    backgroundColor: "bg-white",
    borderWidth: "border-0",
    borderRadius: "rounded-full",
    outline: "outline-none",
    appearance: "appearance-none",
    cursor: "cursor-pointer",
    fontFamily: "font-inherit",
    lineHeight: "leading-inherit"
  }, rest));
});

export default Handle;
//# sourceMappingURL=index.esm.js.map
